import { render, staticRenderFns } from "./endPage.vue?vue&type=template&id=04d32fcf&scoped=true&"
import script from "./endPage.vue?vue&type=script&lang=js&"
export * from "./endPage.vue?vue&type=script&lang=js&"
import style0 from "./endPage.vue?vue&type=style&index=0&id=04d32fcf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d32fcf",
  null
  
)

export default component.exports